import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import AmplifyLanding from "../../components/amplify-leads/AmplifyLanding";

const AmplifyLeads = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <AmplifyLanding userInfoData={userInfoData} />;
};

export default AmplifyLeads;
